export const gists = {
    happyHours: "https://gist.githubusercontent.com/marytomkins/a25ef825b3571312111b34581c0f28e1/raw/happyHours.json?ts=",
    events: "https://gist.githubusercontent.com/marytomkins/547cce901dea5e7d5e96870b68917df2/raw/happenings.json?ts=",
    specials: "https://gist.githubusercontent.com/marytomkins/5d860551674cf9f7026bf8b2e694ade0/raw/specials.json?ts=",
    gameDaySpecials: "https://gist.githubusercontent.com/marytomkins/1ffca4c2dfe53645ed26d40c62ef5e60/raw/gameday.json?ts=",
}